import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";

@Component({
    selector: 'tf-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

    constructor(
        private router: Router
    ) {
    }

    ngOnInit(): void {

        // Get route and redirect based on product type
        const url = this.router.url;
        const productType = url.split('/')[1];

        switch (productType.toLowerCase()) {
            case 'cnv':
                this.router.navigate(['cnv/assay/query'], {
                    queryParams: {
                        keyword: '*',
                        productType: 'cnv',
                        productSubtype: 'cnv'
                    }
                });
                break;
            case 'snp':
                this.router.navigate(['snp/assay/query'], {
                    queryParams: {
                        keyword: '*',
                        productType: 'gt',
                        productSubtype: 'gt'
                    }
                });
                break;
            case 'gene-expression':
                this.router.navigate(['gene-expression/assay/query'], {
                    queryParams: {
                        keyword: '*',
                        productType: 'gt',
                        productSubtype: 'gt'
                    }
                });
                break;
            default:
                this.router.navigate(['results']);
        }
    }

}
